/**
 * Locked Session Prompt Component
 *
 * Displays a message when user tries to access a locked session.
 */

import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

interface LockedSessionPromptProps {
  onUnlock: () => void;
}

export function LockedSessionPrompt({ onUnlock }: LockedSessionPromptProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center text-brand-dark max-w-md px-4">
        <div className="w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
          <Lock className="w-10 h-10 text-gray-400" />
        </div>
        <h3 className="text-xl font-bold mb-2">{t('courses.lockedSession')}</h3>
        <p className="text-brand-dark/70 mb-6">{t('courses.lockedSessionMessage')}</p>
        <button
          onClick={onUnlock}
          className="px-6 py-3 bg-brand-terracotta text-white rounded-lg hover:bg-brand-terracotta-dark font-medium transition-colors"
        >
          {t('courses.unlockCourse')}
        </button>
      </div>
    </div>
  );
}
